import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'






import Inicio from '@/components/Inicio'
import Contacto from '@/components/contacto/Contacto'

import Obra from '@/components/obras/Obra'
import Obras_comerciales_secciones from '@/components/obras/Obras_comerciales_secciones'
import Obras_comerciales from '@/components/obras/Obras_comerciales'
import Obras_corporativas from '@/components/obras/Obras_corporativas'
import Obras_residenciales from '@/components/obras/Obras_residenciales'


import Proyecto from '@/components/proyectos/Proyecto'
import Proyectos_comerciales_secciones from '@/components/proyectos/proyectos_comerciales_secciones'
import Proyectos_comerciales from '@/components/proyectos/Proyectos_comerciales'
import Proyectos_corporativos from '@/components/proyectos/Proyectos_corporativos'
import Proyectos_residenciales from '@/components/proyectos/Proyectos_residenciales'

import Noticias from '@/components/Noticias'
import Noticia from '@/components/Noticia'

import Servicios from '@/components/Servicios'

import Mensaje from '@/components/contacto/Mensaje'
import Trabaja from '@/components/contacto/Trabaja'
import Presupuesto from '@/components/contacto/Presupuesto'

// Cursos
import Escaparatismo from '@/components/cursos/Escaparatismo'
import Visual from '@/components/cursos/Visual'
import Curso from '@/components/cursos/Curso'

import NoEncontrada from '@/components/NoEncontrada'

Vue.use(Router)
Vue.use(Meta)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: Inicio
    },
    {
      path: '/obras_comerciales_secciones',
      name: 'Obras_comerciales_secciones',
      component: Obras_comerciales_secciones
    },

    {
      path: '/obra/:id/:seccion',
      name: 'Obra',
      component: Obra,
      props: { fondoBlack: true }
    },
    {
      path: '/obras_comerciales/:seccion',
      name: 'Obras_comerciales',
      component: Obras_comerciales
    },
    {
      path: '/obras_corporativas',
      name: 'Obras_corporativas',
      component: Obras_corporativas
    },
    {
      path: '/obras_residenciales',
      name: 'Obras_residenciales',
      component: Obras_residenciales
    },
    {
      path: '/proyectos_comerciales_secciones',
      name: 'Proyectos_comerciales_secciones',
      component: Proyectos_comerciales_secciones
    },
    {
      path: '/proyecto/:id/:seccion',
      name: 'Proyecto',
      component: Proyecto
    },
    {
      path: '/Proyectos_comerciales/:seccion',
      name: 'Proyectos_comerciales',
      component: Proyectos_comerciales
    },
    {
      path: '/proyectos_corporativos',
      name: 'Proyectos_corporativos',
      component: Proyectos_corporativos
    },
    {
      path: '/proyectos_residenciales',
      name: 'Proyectos_residenciales',
      component: Proyectos_residenciales
    },

    {
      path: '/noticias',
      name: 'Noticias',
      component: Noticias
    },
    {
      path: '/noticia/:id',
      name: 'Noticia',
      component: Noticia
    },
    {
      path: '/servicios',
      name: 'Servicios',
      component: Servicios
    },



    // contacto
    {
      path: '/mensaje',
      name: 'mensaje',
      component: Mensaje
    },
    {
      path: '/trabaja',
      name: 'trabaja',
      component: Trabaja
    },
    {
      path: '/presupuesto',
      name: 'presupuesto',
      component: Presupuesto
    },

    // cursos proximamente
    {
      path: '/curso/escaparatismo',
      name: 'escaparatismo',
      component: Escaparatismo
    },
    {
      path: '/curso/visual',
      name: 'visual',
      component: Visual
    },
    {
      path: '/curso/curso/:id',
      name: 'curso',
      component: Curso
    },


    // pagina error
    {
      path: '/404',
      name: 'NoEncontrada',
      component: NoEncontrada
    },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js